const cardProps = {
  color: 'primary',
  class: 'card',
};

export default cardProps;
